export var CardHeight = '296px';
export var CardMinWidth = '254px';
export var CardMaxWidth = '368px';
export var CardPreviewHeight = '186px';
export var MeetingAndTaskInfoHeight = '140px';
export var CardHeaderHeight = '32px';
export var CardFooterHeight = '32px';
export var InnerDivHeight = '226px';
export var FileCardPreviewHeight = '182px';
//# sourceMappingURL=StyleConstants.js.map